/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Dashboard_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Create a project, connect a space or upload files as its knowledge, then open a chat and ask a question. The assistant searches that knowledge automatically...." |
*
* @param {Uno_Edu_Intro_Dashboard_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_dashboard_chip1_answer = /** @type {((inputs?: Uno_Edu_Intro_Dashboard_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Dashboard_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie ein Projekt, verbinden Sie einen Space oder laden Sie Dateien als Wissensbasis hoch und öffnen Sie dann einen Chat, um eine Frage zu stellen. Der Assistent durchsucht dieses Wissen automatisch. Nennen Sie mir Ihr Ziel, und ich schlage eine Einrichtung vor.")
	return /** @type {LocalizedString} */ ("Create a project, connect a space or upload files as its knowledge, then open a chat and ask a question. The assistant searches that knowledge automatically. Tell me your goal and I can suggest a setup.")
});